<template>
  <div class="pr-1" v-if="property">
    <h1 class="pt-8 font-light text-gray-500 uppercase">
      {{ property.property_type.name }}
      {{ property.property_tenure_option.name }} in {{ property.address }}
    </h1>
    <h1 class="pt-4 text-2xl font-bold">
      {{ property.title }}
    </h1>
    <div class="grid grid-cols-1 mt-5 md:grid-cols-2 md:gap-x-5 gap-y-3">
      <div class="flex items-center w-full" v-if="property.property_type.name">
        <PropertySvg color="black" height="4" width="4" />
        <p class="text-[#576065] w-44 pl-1">Property type:</p>
        <p class="font-medium">{{ property.property_type.name }}</p>
      </div>
      <div class="flex items-center" v-if="property.property_size">
        <PropertySizeSvg color="black" height="4" width="4" />
        <p class="text-[#576065] w-44 pl-1">Property size:</p>
        <p class="font-medium">{{ property.property_size }}</p>
      </div>
      <div class="flex items-center w-full">
        <BedSvg color="black" height="5" width="5" />
        <p class="text-[#576065] w-44 pl-1">Bedrooms:</p>
        <p class="font-medium">
          {{ property.number_of_beds }}
          <span v-if="property.maid_bedroom != null">+ Maid</span>
        </p>
      </div>
      <div class="flex items-center" v-if="property.number_of_baths">
        <BathSvg color="black" height="6" width="6" />
        <p class="text-[#576065] w-44 pl-1">Bathrooms:</p>
        <p class="font-medium">{{ property.number_of_baths }}</p>
      </div>
      <div class="flex" v-if="property.service_charge">
        <p class="text-[#576065] w-44 pl-1">Service Charges:</p>
        <p class="font-medium">{{ property.service_charge }}</p>
      </div>
    </div>
    <!-- <div class="grid grid-cols-2 gap-5 mt-5 mb-8">
      <div class="bg-[#f8f8f8] p-4 rounded-lg flex flex-col">
        <button
          class="flex items-center w-[5.3rem] justify-center h-5 text-xs font-semibold text-white uppercase bg-green-500 rounded shadow"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-4 h-4"
          >
            <path
              fill-rule="evenodd"
              d="M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="ml-1 tracking-wide">Verified</span>
        </button>
        <p class="pt-1 text-xs leading-normal tracking-normal">
          Verified listings have passed through our verification process, where
          the authenticity of the documentation, location, and price are all
          checked.
        </p>
      </div>
      <div class="bg-[#f8f8f8] p-4 rounded-lg flex flex-col">
        <button
          class="flex items-center h-5 text-xs font-semibold w-[7rem] justify-center text-white uppercase bg-primary rounded shadow"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-4 h-4"
          >
            <path
              fill-rule="evenodd"
              d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="ml-1 tracking-wide">SuperAgent</span>
        </button>
        <p class="pt-1 text-xs leading-normal tracking-normal line-clamp-5">
          A SuperAgent provides the best possible information with the most
          up-to-date listings in the market, all while ensuring to respond to
          home seekers faster than the rest.
        </p>
        <a
          href="/registration-enquiry"
          class="text-xs leading-relaxed tracking-wider text-primary"
          >Learn more about SuperAgent</a
        >
      </div>
    </div> -->
    <hr class="my-10" />

    <div class="grid grid-cols-2 gap-5">
      <div>
        <h1 class="text-xl font-semibold text-gray-700">Location</h1>
        <div class="flex flex-row items-center mt-4 space-x-2 md:space-x-5">
          <div
            class="relative flex items-center justify-center w-16 h-16 rounded-full md:w-32 md:h-32"
            :style="{ backgroundImage: `url(${mapImage})` }"
          >
            <button
              @click="openViewModal()"
              class="px-3 py-1 text-sm font-medium bg-white border rounded-md text-primary border-primary"
            >
              Map
            </button>
          </div>
          <!-- <img
            src="@/assets/images/map.svg"
            class="w-16 h-16 rounded-full md:w-32 md:h-32"
            alt=""
          /> -->
          <div>
            <p class="text-xs md:text-base">{{ property.address }}</p>
            <p class="pt-3 text-xs md:text-base">
              Ghana, {{ property.town.name }}
            </p>
          </div>
        </div>
      </div>
      <div>
        <h1 class="text-xl font-semibold text-gray-700">Agent</h1>
        <div class="flex flex-row items-center mt-4 space-x-2 md:space-x-5">
          <img
            v-if="property.agent"
            :src="property.agent.photo"
            class="w-16 h-16 rounded-full md:w-32 md:h-32"
            alt=""
          />
          <div
            v-else
            class="w-16 h-16 bg-gray-300 rounded-full md:w-32 md:h-32"
          ></div>
          <div v-if="property.agent">
            <a
              :href="
                $router.resolve({
                  name: 'AgentView',
                  params: {
                    id: property.agent.id,
                    slug: $sanitizeTitle(property.agent.name),
                  },
                }).href
              "
              class="text-base font-medium text-primary"
              >{{ property.agent.name }}</a
            >
            <div class="flex-col pt-3 md:flex md:flex-row md:space-x-2">
              <img
                :src="property.agent.company.photo"
                class="w-10 h-6"
                alt=""
              />
              <div>
                <p class="text-sm font-light">
                  {{ property.agent.company.name }}
                </p>
                <p class="flex flex-row text-sm font-light text-blue-400">
                  ({{ property.agent.company.properties_count }} properties)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div
        class="flex flex-row items-center p-2 space-x-2 border border-gray-200 md:p-3 md:space-x-4 rounded-xl"
      >
        <div
          class="md:w-[110px] md:h-[110px] h-20 w-20 bg-gray-200 rounded-xl"
        ></div>
        <div class="flex flex-col items-start w-full md:w-56">
          <p class="text-xs">Residential insights</p>
          <h6 class="pt-1 text-sm font-semibold">Vida Residences Dubai Mall</h6>
        </div>
        <div>
          <svg
            width="8"
            height="16"
            viewBox="0 0 4 15"
            fill="none"
            class="w-4 h-4"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.146447 0.646447C0.320013 0.47288 0.589437 0.453595 0.784306 0.588591L0.853553 0.646447L7.85355 7.64645C8.02712 7.82001 8.0464 8.08944 7.91141 8.28431L7.85355 8.35355L0.853553 15.3536C0.658291 15.5488 0.341709 15.5488 0.146447 15.3536C-0.0271197 15.18 -0.0464049 14.9106 0.0885912 14.7157L0.146447 14.6464L6.79296 8L0.146447 1.35355C-0.0271197 1.17999 -0.0464049 0.910563 0.0885912 0.715695L0.146447 0.646447Z"
              fill="#707070"
            ></path>
          </svg>
        </div>
      </div> -->

      <!-- <div
        class="flex flex-row items-center p-2 space-x-2 border border-gray-200 md:p-3 md:space-x-4 rounded-xl"
      >
        <div
          class="md:w-[110px] md:h-[110px] h-20 w-20 bg-gray-200 rounded-xl"
        ></div>
        <div class="flex flex-col items-start w-full md:w-56">
          <p class="text-xs">Community insights</p>
          <h6 class="pt-1 text-sm font-semibold">Downtown Dubai</h6>
        </div>
        <div>
          <svg
            width="8"
            height="16"
            viewBox="0 0 4 15"
            fill="none"
            class="w-4 h-4"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.146447 0.646447C0.320013 0.47288 0.589437 0.453595 0.784306 0.588591L0.853553 0.646447L7.85355 7.64645C8.02712 7.82001 8.0464 8.08944 7.91141 8.28431L7.85355 8.35355L0.853553 15.3536C0.658291 15.5488 0.341709 15.5488 0.146447 15.3536C-0.0271197 15.18 -0.0464049 14.9106 0.0885912 14.7157L0.146447 14.6464L6.79296 8L0.146447 1.35355C-0.0271197 1.17999 -0.0464049 0.910563 0.0885912 0.715695L0.146447 0.646447Z"
              fill="#707070"
            ></path>
          </svg>
        </div>
      </div> -->
    </div>
    <Amenities :property="property" />
    <Description :property="property" />
    <!-- <SocialMedia /> -->
    <MapModal
      :address="address"
      :showViewModal="showMapModal"
      @closeViewModal="closeModal"
    />
  </div>
</template>
<script setup>
import { ref, defineProps } from "vue";
import mapImage from "@/assets/images/map.svg";
import Amenities from "./AmenitiesView.vue";
import Description from "./DescriptionView.vue";
import MapModal from "./MapModal.vue";
// import SocialMedia from "./SocialMedia.vue";
import PropertySvg from "@/components/svg/PropertySvg.vue";
import PropertySizeSvg from "@/components/svg/PropertySizeSvg.vue";
import BathSvg from "@/components/svg/BathSvg.vue";
import BedSvg from "@/components/svg/BedSvg.vue";

// Define props
defineProps({
  property: Object,
});

// State
const showMapModal = ref(false);

// Methods
const openViewModal = () => {
  showMapModal.value = true;
};

const closeModal = () => {
  showMapModal.value = false;
};
</script>
